import React, { useState } from "react";
import { FaSearch, FaTimes } from "react-icons/fa";
import { HiMiniBars3CenterLeft } from "react-icons/hi2";
import Logo from '../images/SuperCodingBitsNewLogo.png'
import "./Header.css";

const Header = () => {
  const [isNavActive, setIsNavActive] = useState(false);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");


  const handleMenuClick = () => {
    setIsNavActive(true);
  };

  const handleCancelClick = () => {
    setIsNavActive(false);
    setIsSearchActive(false);
    setSearchQuery("");
  };

  const handleSearchClick = () => {
    setIsSearchActive(true);
  };

  const handleInputChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      const googleSearchUrl = `https://www.google.com/search?q=${encodeURIComponent(searchQuery)}`;
      window.open(googleSearchUrl, "_blank"); // Opens in a new tab
    }
  };

  return (
    <nav>
      {/* <div className="menu-icon" onClick={handleMenuClick}>
        <HiMiniBars3CenterLeft />
      </div> */}
      <div className="logo"><img src={Logo} alt="" /></div>
      <div className="search-icon" onClick={handleSearchClick}>
        <FaSearch />
      </div>
      <div
        className={`cancel-icon ${isNavActive || isSearchActive ? "show" : ""}`}
        onClick={handleCancelClick}
      >
        <FaTimes />
      </div>
      <form
        className={isSearchActive ? "active" : ""}
        onSubmit={handleSearchSubmit}
      >
        <input
          type="search"
          className="search-data"
          placeholder="Search"
          value={searchQuery}
          onChange={handleInputChange}
          required
        />
        <button type="submit">
          <FaSearch />
        </button>
      </form>
    </nav>
  );
};

export default Header;
